import { useState } from 'react';

import { FiSearch } from 'react-icons/fi';

import AutoComplete from '@components/AutoComplete';

import { FieldRendererProps } from '../types';

const AutocompleteField = ({ field, disabled }: FieldRendererProps) => {
  const [, setIsInputOtherVisible] = useState(false);

  const params = field.autocomplete_params
    ? Object.entries(field.autocomplete_params).map(([name, value]) => ({
        name,
        value,
      }))
    : [];

  return (
    <AutoComplete
      name={field.name}
      placeholder={field.placeholder || field.label}
      icon={FiSearch}
      disabled={disabled}
      required={field.is_required}
      url={field.autocomplete_url}
      params={params}
      setIsInputOtherVisible={setIsInputOtherVisible}
    />
  );
};

export default AutocompleteField;
